import React from "react";
import * as styles from "./style.module.css";

type Props = {
    toc: string
}


export const Toc: React.FunctionComponent<Props> = ({toc}) => {
    return (
        <div className='my-14  py-8 px-16 bg-sub-100 rounded' >
            <h2 className='text-center font-bold  text-xl'>目 次</h2>
            <div dangerouslySetInnerHTML={{__html:toc}} className={styles.container}/>
        </div>
    )
}
